import * as React from 'react';
import { Icon } from '@teamsnap/teamsnap-ui';
import HistoryInfo from '../../components/member/history-info';
import memberHistoryActivity from '../../models/member-history-activity';

interface Props {
  orgId: number;
  memberId: number;
  memberHistoryActivities: memberHistoryActivity[];
}

const renderMemberHistory = (memberHistoryActivities) => {
  if (memberHistoryActivities?.length > 0) {
    return (
      <>
        <div className="Panel-row">
          <div className="Grid Grid--fit Grid--withGutter">
            <div className="Grid-cell">
              <p className="u-pad u-textSemiBold">Time</p>
            </div>
            <div className="Grid-cell">
              <p className="u-pad u-textSemiBold">User</p>
            </div>
            <div className="Grid-cell">
              <p className="u-pad u-textSemiBold">Event</p>
            </div>
            <div className="Grid-cell">
              <p className="u-pad u-textSemiBold">Description</p>
            </div>
          </div>
        </div>
        {memberHistoryActivities.map((memberHistoryActivity) => (
          <div className="Panel-row">
            <HistoryInfo
              memberHistoryActivity={memberHistoryActivity}
              key={`history-activity-info-${memberHistoryActivity.id}`}
            />
          </div>
        ))}
      </>
    );
  } else {
    return <div className="Panel-row">There is no activity for this member.</div>;
  }
};

const MemberHistoryOverview: React.FunctionComponent<Props> = ({ orgId, memberId, memberHistoryActivities }) => (
  <div className="Panel Panel--striped">
    <div className="Panel-body">{renderMemberHistory(memberHistoryActivities)}</div>
  </div>
);

export default MemberHistoryOverview;
